import React from 'react';
import { Table } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { array, string } from 'prop-types';
import OfferLandingsTableItem from './OfferLandingsTableItem.js';
import { currencyToSign } from '../../../../utils/utils';

const propTypes = {
  landings: array.isRequired,
  name: string.isRequired,
  currency: string.isRequired,
};

const defaultProps = {
  landings: [],
};

const OfferLandingsTable = ({ hover, landings, name, currency, offer, site_key, connectOffer }) => {
  const {
    modifies: { is_cdn, g },
  } = offer;
  return (
    <Table hover={hover} className="offer-landings-table no-margin" responsive bordered>
      <thead>
        <tr>
          {/* <th className="platform" /> */}
          <th>
            <FormattedMessage id="offer.landings-table.title" defaultMessage="Title" />
          </th>
          {/* <th /> */}
          {!g && <th className="values">CR, %</th>}
          {/* <th className="values">EPC, {currencyToSign(currency)}</th> */}
          <th></th>
          {is_cdn ? <th>{''}</th> : null}
        </tr>
      </thead>
      <tbody>
        {landings.length > 0 &&
          landings.map(landing => (
            <OfferLandingsTableItem
              key={landing.id}
              name={name}
              {...landing}
              offer={offer}
              connectOffer={connectOffer}
              site_key={site_key}
            />
          ))}
      </tbody>
    </Table>
  );
};

OfferLandingsTable.propTypes = propTypes;
OfferLandingsTable.defaultProps = defaultProps;

export default OfferLandingsTable;
